import React from 'react';
import PublicCmsPage from 'components/PublicCmsPage';

const PrivacyPolicy = () => {
  return <PublicCmsPage />;
};

export default PrivacyPolicy;
